import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 0C4.9 0 0 4.79 0 10.753s4.9 10.754 11 10.754 11-4.79 11-10.754S17.1 0 11 0m8.9 9.775h-4c-.2-2.737-1.1-5.278-2.7-7.527 3.6.88 6.3 3.91 6.7 7.527M8.1 11.731H14c-.3 2.64-1.3 5.18-2.9 7.234-1.8-2.053-2.8-4.595-3-7.234m0-1.956c.3-2.639 1.3-5.18 2.9-7.234 1.7 2.151 2.7 4.693 2.9 7.234zm.6-7.527c-1.5 2.249-2.4 4.79-2.6 7.527h-4c.4-3.617 3.1-6.647 6.6-7.527m-6.6 9.483h4c.2 2.737 1.1 5.279 2.7 7.527-3.6-.88-6.3-3.91-6.7-7.527m11.2 7.527c1.5-2.248 2.4-4.79 2.7-7.527h4c-.5 3.617-3.2 6.647-6.7 7.527"
    }, null, -1)
  ]))]))
}
export default { render: render }